<template>
    <div class="row">
        <div class="col-md-12">
            <section class="panel">
                <header class="panel-heading">
                    <h2 class="panel-title">查詢條件</h2>
                </header>
                <div class="panel-body container-fluid">
                    <div class="row form-group">
                        <div class="col-md-12 form-group">
                            <label for="report" class="column-required">報表</label>
                            <select id="report" name="report" v-validate="'required'" v-model="form.report" class="form-control" :style="{width:'auto', display:'inline-block'}">
                                <option value="" >請選擇</option>
								<option v-for="(item,key) in reportList" :key="key" :value="item.key">{{ item.value }}</option>
                            </select>
                        </div>
                        <div class="col-md-12 form-group">
                            <label for="ssym" class="column-required">學年度</label>
                            <select id="ssym" name="ssym" v-validate="'required'" v-model="form.ssym" class="form-control" :style="{width:'auto', display:'inline-block'}">
                                <option value="">請選擇</option>
                                <option v-for="item in ssymList" :key="item" :value="item">{{item}}</option>
                            </select>
                        </div>
                        <div v-if="form.report != 2" class="col-md-12 form-group" >
                            <label for="smtr" class="column-required">學期</label>
                            <select id="smtr" name="smtr" v-validate="'required'" v-model="form.smtr" class="form-control" :style="{width:'auto', display:'inline-block'}">
                                <option value="">請選擇</option>
                                <option v-for="item in smtrList" :key="item" :value="item">{{item}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="btn-group">
                        <button @click="handleDownload" class="btn s_btn_b">下載</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    data() {
		return {
            ssymList: [],
            smtrList: [],
			reportList: [
				{
					key: "1",
					value: "核結一覽表"
				},
				{
					key: "2",
					value: "彙整表"
				},
				{
					key: "3",
					value: "日間部退費"
				},
				{
					key: "4",
					value: "日間部不退費"
				},
				{
					key: "5",
					value: "日間部休退學"
				},
				{
					key: "6",
					value: "進修部退費"
				},
				{
					key: "7",
					value: "進修部不退費"
				},
				{
					key: "8",
					value: "進修部休退學"
				},
				{
					key: "9",
					value: "全校減免清冊"
				}
			],
            form: {
                report: "",
                ssym: "",
                smtr: ""
            }
		}
	},
    mounted() {
        this.$http.get("/api/reliefFee/smtrList").then((res) => {
            if(res.data.data.length > 0) {
                res.data.data.map((item) => {
                    this.ssymList.push(item.substr(0, 3));
                    this.smtrList.push(item.substr(3, 1));
                });

                this.ssymList = this.ssymList.filter(this.uniqueList).sort().reverse();
                this.smtrList = this.smtrList.filter(this.uniqueList).sort();

                this.form.ssym = this.ssymList[0];
                this.form.smtr = this.smtrList[0];
            }
        });
    },
	methods: {
		handleDownload() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const api = `/api/relief/export/report`;

                    const query = new URLSearchParams({
                        type: this.form.report,
                        year: this.form.ssym,
                        smtr: this.form.report == 2 ? "" : this.form.smtr
                    }).toString();
                    this.$axios.get(`${api}?${query}`, {
                        responseType: 'blob'
                    }).then(resp => {
                        const url = window.URL.createObjectURL(new Blob([resp.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        const reportName = this.reportList.find(r => r.key == this.form.report).value;
                        link.setAttribute('download', `減免_${this.form.ssym}${this.form.report == 2 ? "" : this.form.smtr}_${reportName}_${this.customFormatter(new Date(),"YYYYMMDD")}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                    });
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});
		},
        uniqueList(value, index, self) {
            return self.indexOf(value) === index;
        }
	},
	computed:{
	}
}
</script>

<style scoped>
</style>
